"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useGetUserMedia = require("./useGetUserMedia");
Object.keys(_useGetUserMedia).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetUserMedia[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useGetUserMedia[key];
    }
  });
});